module.exports = __webpack_public_path__ + "static/media/modal-decoline.7a86624b.svg";